const ROUTES = {
  SIGN_IN: "/signIn",
  SIGN_UP: "/signUp",
  REGISTRATION_CLOSED: "/registrationClosed",
  AUTH: {
    CHECK_EMAIL: "/auth/emailVerification",
    ACTIVATE_ACCOUNT: "/auth/activateAccount",
    FORGOT_PASSWORD: "/auth/forgotPassword",
    RESET_PASSWORD: "/auth/resetPassword",
    AUTO_LOGIN: "/autoLogin",
    API_ACCESS: "/auth/apiAccess",
  },
  STATISTICS: {
    BASE: "/statistics",
    ADV: "/adv/statistics",
  },
  PROFILE: "/profile",
  SUBSCRIBERS: "/subscribers",
  DOCUMENTATION: "/documentation",
  MAILINGS: "/mailings",
  AUDIENCES: "/audiences",
  SITES: {
    LIST: "/sites/list",
    CREATE: "/sites/create",
    ITEM: "/sites/:siteId",
    GET_TAG: "/site/:siteId/zone/:zoneId",
  },
  SENDINGS: "/messages",
  CREATE_SENDING: "/messages/create",
  SENDING_VIEW: "/messages/view",
  SUBSCRIPTIONS: "/subscriptions",
  INTEGRATIONS: "/integrations",
  PIXELS: "/audience-pixels",
  CREATE_RSS: "/create-rss",
  INVOICES: "/invoices",
  BILLING: "/billing",
  WELCOME: "/welcome",
  TEST: "/test-invisible",
  RSS_LIST: "/rss-list",
  MONETIZATION_REQUEST: "/monetization-requests",
};

export default ROUTES;
